import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BaseModalComponent, TranslatePipe],
})
export class ErrorModalComponent {
  @Input() headline!: string;
  @Input() message!: string;
  @Input() actionLabel?: string;

  @Output() requestCancel = new EventEmitter();
  @Output() requestAction = new EventEmitter();

  closeError() {
    this.requestCancel.emit();
  }

  triggerAction() {
    this.requestAction.emit();
  }
}
